import { yup } from '@framework/validation/initYup.ts';
import { ExpressionType } from '../../IExpression.ts';
import { DefaultAssignableExpressionSchema } from '../assignable/AssignableExpressionSchema.ts';
import {
  ComputedDateOffsetUnit,
  type IComputedDateExpression,
} from './IComputedDateExpression.ts';

export const ComputedDateExpressionSchema = yup
  .object({
    type: yup
      .string()
      .exact(ExpressionType.ComputedDate)
      .required()
      .label('Tipo di condizione')
      .transform(() => ExpressionType.ComputedDate),
    from: DefaultAssignableExpressionSchema,
    offsets: yup
      .array(
        yup.object({
          unit: yup
            .string()
            .oneOfEnum(ComputedDateOffsetUnit)
            .required()
            .label('Unità di misura'),
          amount: DefaultAssignableExpressionSchema,
        }),
      )
      .default([])
      .required(),
  })
  .noUnknown()
  .meta({
    expression: ExpressionType.ComputedDate,
  }) satisfies yup.ObjectSchema<IComputedDateExpression>;
